import { render } from "./detail.vue?vue&type=template&id=8e6c5e8e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=8e6c5e8e&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e6c5e8e"]])

export default __exports__